import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import dotenv from 'dotenv'
import * as urls from "../../helpers/url_helper"

dotenv.config()
const url = process.env.LOCALHOST ? process.env.LOCALHOST : 'https://qa_api_gtc.amerck.com'

export const routeTypeAPI = createApi({
  reducerPath: 'routeTypeApi',
  baseQuery: fetchBaseQuery({ baseUrl: url, timeout: 10000 }),
  tagTypes: ['RouteType'],
  endpoints: (builder) => ({
    getRouteTypes: builder.query({
      query: () => ({
        url: urls._GET_ROUTE_TYPES,
        method: 'GET',
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
        },
        timeout: 5000,
      }),
      providesTags: ['RouteType']
    }),
    
    createRouteType: builder.mutation({
      query: (routeType) => ({
        url: urls._CREATE_ROUTE_TYPE,
        method: 'POST',
        body: routeType,
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
        },
      }),
      invalidatesTags: ['RouteType']
    }),
    
    updateRouteType: builder.mutation({
      query: ({ id, ...routeType }) => ({
        url: `${urls._UPDATE_ROUTE_TYPE}/${id}`,
        method: 'PUT',
        body: routeType,
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
        },
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'RouteType', id }]
    }),
    
    deleteRouteType: builder.mutation({
      query: (id) => ({
        url: `${urls._DELETE_ROUTE_TYPE}/${id}`,
        method: 'DELETE',
        headers: {
          auth: JSON.parse(localStorage.getItem("authUser")),
        },
      }),
      invalidatesTags: ['RouteType']
    }),
  }),
})

export const {
  useGetRouteTypesQuery,
  useCreateRouteTypeMutation,
  useUpdateRouteTypeMutation,
  useDeleteRouteTypeMutation,
} = routeTypeAPI 